import { render, staticRenderFns } from "./LdsRippleWaiter.vue?vue&type=template&id=2a62837d&scoped=true&"
import script from "./LdsRippleWaiter.vue?vue&type=script&lang=js&"
export * from "./LdsRippleWaiter.vue?vue&type=script&lang=js&"
import style0 from "./LdsRippleWaiter.vue?vue&type=style&index=0&id=2a62837d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a62837d",
  null
  
)

export default component.exports